import React from "react";
import Marquee from "@/components/Marquee";

export default function CasinoMalaysia() {
  return (
    <div className="bg-black text-white min-h-screen overflow-hidden">
      {/* 
        SEO 核心策略：
        1. 关键词增强：将 "Trusted," "Real Money," "Slot," "Baccarat" 融入文案。
        2. 增加内容厚度：通过 FAQ 和列表提高页面在搜索结果中的展示面积。
      */}

      {/* HERO SECTION */}
      <section className="relative py-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">

          {/* LEFT CONTENT */}
          <div>
            <div className="inline-block px-4 py-2 rounded-full border border-orange-500/30 bg-orange-500/10 text-orange-400 text-sm font-bold tracking-widest mb-6">
              #1 TRUSTED MALAYSIA ONLINE GAMING PLATFORM
            </div>

            <h1 className="text-5xl lg:text-7xl font-black leading-tight mb-6 uppercase">
              TRUSTED
              <br />
              <span className="text-orange-500 drop-shadow-[0_0_25px_rgba(249,115,22,0.8)]">
                CASINO MALAYSIA
              </span>
            </h1>

            <p className="text-zinc-400 text-lg leading-8 max-w-2xl mb-10">
              U2 Gaming is the premier destination for <strong>Online Casino Malaysia</strong> enthusiasts. 
              We offer a secure environment for <strong>real money gambling</strong>, featuring 
              top-tier <strong>online slots</strong>, live dealer baccarat, and sports betting with 
              the fastest withdrawal speeds in the industry.
            </p>

            <div className="flex flex-wrap gap-4">
              <a
                href="https://regismyr.wlrdr.xyz/RE/NjljZGRlZWVlNjY0NjRmNjRiN2U0OWQ4"
                target="_blank"
                rel="noreferrer"
                className="px-8 py-4 rounded-full bg-orange-500 hover:bg-orange-400 transition-all duration-300 text-black font-bold shadow-[0_0_30px_rgba(249,115,22,0.5)]"
              >
                Join & Play Now
              </a>

              <a
                href="/contact"
                className="px-8 py-4 rounded-full border border-orange-500 text-orange-400 hover:bg-orange-500 hover:text-black transition-all duration-300 font-semibold"
              >
                Get 24/7 Support
              </a>
            </div>
          </div>

          {/* RIGHT CONTENT - 优化卡片数据和术语 */}
          <div className="grid grid-cols-2 gap-5">
            <div className="rounded-3xl border border-orange-500/20 bg-zinc-900/70 p-8 hover:scale-105 transition-all duration-300">
              <h2 className="text-4xl font-black text-orange-500 mb-2">99%</h2>
              <p className="text-xl font-bold mb-2">WIN RATE</p>
              <p className="text-zinc-500 text-sm leading-6">
                High RTP <strong>online slot games</strong> and fair play certified systems.
              </p>
            </div>

            <div className="rounded-3xl border border-orange-500/20 bg-zinc-900/70 p-8 hover:scale-105 transition-all duration-300">
              <h2 className="text-4xl font-black text-orange-500 mb-2">5 MIN</h2>
              <p className="text-xl font-bold mb-2">FAST PAYOUT</p>
              <p className="text-zinc-500 text-sm leading-6">
                Instant <strong>casino deposit and withdrawal</strong> via local Malaysia banks.
              </p>
            </div>

            <div className="rounded-3xl border border-orange-500/20 bg-zinc-900/70 p-8 hover:scale-105 transition-all duration-300">
              <h2 className="text-4xl font-black text-orange-500 mb-2">LIVE</h2>
              <p className="text-xl font-bold mb-2">REBATES</p>
              <p className="text-zinc-500 text-sm leading-6">
                Unlimited daily rebates for <strong>Live Casino</strong> and Sportsbook players.
              </p>
            </div>

            <div className="rounded-3xl border border-orange-500/20 bg-zinc-900/70 p-8 hover:scale-105 transition-all duration-300">
              <h2 className="text-4xl font-black text-orange-500 mb-2">SECURE</h2>
              <p className="text-xl font-bold mb-2">ENCRYPTION</p>
              <p className="text-zinc-500 text-sm leading-6">
                Bank-grade SSL security ensures your gaming data remains private.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ENHANCED SEO SECTION - 核心排名区 */}
      <section className="py-20 border-t border-orange-500/10 bg-zinc-950">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-10 text-zinc-300">

          <h2 className="text-4xl lg:text-5xl font-black text-white mb-8 text-center uppercase">
            The #1 <span className="text-orange-500">Online Casino Malaysia</span> Platform
          </h2>

          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <p className="leading-8 text-lg text-zinc-400 mb-6">
                U2 Gaming is recognized as the most <strong>reliable online gambling site in Malaysia</strong>. 
                We partner with world-class providers like <strong>Evolution Gaming, Pragmatic Play, and Mega888</strong> 
                to bring you an unmatched library of over 500+ premium titles. 
              </p>
              <ul className="space-y-3 text-orange-400 font-semibold">
                <li>✓ Certified Trusted Online Casino 2024</li>
                <li>✓ Mobile Responsive Design for iOS & Android</li>
                <li>✓ 24/7 Professional WhatsApp & Telegram Support</li>
                <li>✓ High-Limit Live Dealer Tables</li>
              </ul>
            </div>

            <div className="bg-zinc-900/50 p-8 rounded-3xl border border-orange-500/10">
              <h3 className="text-2xl font-bold text-white mb-6">Frequently Asked Questions</h3>
              <div className="space-y-6">
                <div>
                  <h4 className="text-orange-400 font-bold mb-2">Is it safe to play at U2 Casino Malaysia?</h4>
                  <p className="text-sm text-zinc-500 italic">Yes, we use advanced 128-bit encryption and are licensed to ensure fair play and secure transactions.</p>
                </div>
                <div>
                  <h4 className="text-orange-400 font-bold mb-2">What is the minimum deposit?</h4>
                  <p className="text-sm text-zinc-500 italic">We offer low entry barriers to welcome all Malaysia players to start their journey.</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* MARQUEE */}
      <Marquee />

    </div>
  );
}
